import { Alert } from '@material-ui/lab';
import { Snackbar } from '@material-ui/core';

const ErrorMessage = ({ errorMsg, clearErrorMsg }) => {
  if (!errorMsg) {
    return null;
  }

  return (
    <Snackbar
    open={errorMsg}
    onClose={clearErrorMsg}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    
  >
    <Alert onClose={clearErrorMsg} variant="filled" severity='error'>
    {errorMsg}
    </Alert>
  </Snackbar>
  );
};

export default ErrorMessage;
